import { Injectable, inject } from "@angular/core";
import { LorenAssetService } from "../../../../features/loren-assets/services/loren-asset-service/loren-asset.service";
import { LorenGroupService } from "../../../../features/loren-groups/services/loren-group-service/loren-group.service";
import { switchMap } from "rxjs/operators";
import { forkJoin } from "rxjs";
import { GroupItemModel } from "../group.interface";
import { HierarchyModificationDialogData } from "../hierarchy-modification-dialog/hierarchy-modification-dialog.component";

@Injectable({
  providedIn: "root",
})
export class LorenHierarchyService {
  private lorenAssetService = inject(LorenAssetService);
  private lorenGroupService = inject(LorenGroupService);


  hierarchyData$ = () =>
    LorenGroupService.newGroupCreated$.pipe(
      switchMap(() =>
        forkJoin([
          this.lorenGroupService.getHierarchySelectorData(),
          this.lorenAssetService.query(),
        ])
      )
    );

  saveHierarchyData$ = (
    node: GroupItemModel,
    userInput: HierarchyModificationDialogData
  ) => {
    if (userInput.action === "addGroup") {
      const group: GroupItemModel = {
        assetsInGroup: userInput.selectedAssets.map((x) => x.id),
        name: userInput.newGroupName,
        description: userInput.newGroupDescription,
        parentGroupId: node.id,
        id: null,
      };

      return this.lorenGroupService.create(group);
    }

    // only update assets
    if (userInput.action === "addAsset") {
      return this.lorenGroupService.update(node.id, {
        assetsInGroup: userInput.selectedAssets.map((x) => x.id),
        name: node.name,
        description: node.description,
        parentGroupId: node.parentGroupId,
        id: node.id,
      });
    }

    if (userInput.action === "editGroup") {
      return this.lorenGroupService.update(node.id, {
        assetsInGroup: node.assetsInGroup,
        name: node.name,
        description: node.description,
        parentGroupId: node.parentGroupId,
        id: node.id,
      });
    }
  };

  deleteHierarchyData$ = (node: GroupItemModel) => {
    if (node.isAsset) {
      return this.lorenGroupService.get(node.parentGroupId).pipe(
        switchMap((g) =>
          this.lorenGroupService.update(g.id, {
            ...g,
            assetsInGroup: g.assetsInGroup.filter((x) => x !== node.id),
          })
        )
      );
    }

    return this.lorenGroupService.del(node.id);
  };
}
